const km = {
  text_product: "ផលិតផល",
  text_location: "ទីតាំង",
  text_locations: "ទីតាំង",
  text_request: "ការស្នើសុំ",
  text_date: "កាលបរិច្ឆេទ",
  text_products_to_count: "ផលិតផលដែលត្រូវរាប់",
  text_counted_quantity: "បរិមាណដែលបានរាប់",
  text_cancel: "បោះបង់",
  text_submit: "ដាក់ស្នើ",
  text_outlet: "ទីតាំង",
  text_description: "ការពិពណ៌នា",
  text_order_products: "បញ្ជាទិញផលិតផល",
  text_order_quantity: "បរិមាណបញ្ជាទិញ",
  text_send_order: "ផ្ញើការបញ្ជាទិញ",
  text_please_input_description: "សូមបញ្ចូលការពិពណ៌នា!",
  text_anouncement: 'សេចក្តីប្រកាស',
  text_sale_product: "ផលិតផលលក់",
  text_sale_quantity: "បរិមាណលក់",
  text_send_sale: "ធ្វើការលក់",
  //calendar
  text_su: 'អ.ទ',
  text_mo: 'ច័ន្ទ',
  text_tu: 'អង្គារ',
  text_we: 'ពុធ',
  text_th: 'ព្រ.ហ',
  text_fr: 'សុក្រ',
  text_sa: 'សៅរ៍',
  // month 
  text_jan : 'មករា',
  text_feb : 'កុម្ភៈ',
  text_mar : 'មិនា',
  text_apr : 'មេសា',
  text_May : 'ឧសភា',
  text_jun : 'មិថុនា',
  text_jul : 'កក្កដា',
  text_aug : 'សីហា',
  text_sep : 'កញ្ញា',
  text_oct : 'តុលា',
  text_nov : 'វិច្ឆិកា',
  text_dec : 'ធ្នូ',

  //   message error antd

  text_please_enter_product_quantity_at_lest_one:
    "សូមបញ្ចូលបរិមាណផលិតផលយ៉ាងហោចណាស់មួយ!",
  text_do_you_have_any_note_for_your_order: "តើអ្នកមានការកំណត់ចំណាំសម្រាប់ការបញ្ជាទិញរបស់អ្នកទេ?",
  text_do_you_have_any_note_for_your_sale: "តើអ្នកមានការកំណត់ចំណាំសម្រាប់ការលក់របស់អ្នកទេ?",
  text_search: "ស្វែងរក",
  text_no_data: "គ្មាន​ទិន្នន័យ",

};

export default km;
